/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-len */
/* eslint-disable import/first */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import gql from 'graphql-tag';
import {FeatureFlag} from 'react-launch-darkly';

import gqlClient from 'js/graphql/client/gqlClient';
import {getCampaignWorkflow} from 'js/common/workflows';
import {track} from 'js/common/analytics';
import {ENUMS} from 'js/common';
import {
    DisplayMode,
    CardStyles,
    SliderMarks,
    SliderMarksArray
} from './posts_controls_row/controls_helper';

// Components
import LoaderSpinner from 'js/campaign_analytics/v2/campaign_analytics_page/loader_spinner';
import PostGridOptions from './post_grid_options';
import PostsControlsRow from './posts_controls_row';
import ContentFiltersTabs from './content_filters_tabs';
import PostsList from './posts_list';
import PostGrid from './post_grid';
import ImageModal from './image_modal/';
import VideoModal from './video_modal/';
import RateCreatorsList from './rate_creators';
import ClearAllFiltersControl from './posts_controls_row/clear_all_filters_control';

// Icons
import FacebookPlusSocialNativeIcon from 'images/icons/svg/facebook-plus-socialnative.svg';
import TikTokPlusSocialNativeIcon from 'images/icons/svg/tiktok-plus-socialnative.svg';

import checkBrandUserSession from 'js/brand_session';
import {getAuth0Storage} from 'js/auth0_storage';

const {ContentType} = ENUMS;

class AnalyticsPostsContainer extends Component {
    static defaultProps = {
        displayDatePicker: true
    };

    constructor(props) {
        super(props);

        const {sn} = window;
        const {isAgency, isBrand, isAdmin} = sn;

        this.state = {
            currentCardSize: CardStyles.SMALL,
            currentDisplayMode: DisplayMode.GRID,
            oldDisplayMode: DisplayMode.NONE,
            currentContentType: `${ContentType.IMAGE}|${ContentType.VIDEO}`,
            currentSliderPosition: 38,
            includeContentFilters: [],
            excludeContentFilters: [],
            enableClickTracking: false,
            expanded: false,
            showBanner: true,
            isHideTikTokBanner: !isAdmin && (isBrand || isAgency),
            rateCreatorsMode: false,
            previewAdMode: false,
            compositionMetrics: undefined,
            isFbBusinessConnected: null,
            isTikTokBusinessConnected: null
        };
    }

    async componentDidMount() {
        if (!window.sn.isSharedCampaignView) {
            await checkBrandUserSession();
            this.fetchCompositionMetrics();
            this.fetchUserIdentities();
        }
    }

    /**
     * @typedef Auth0IdentityData
     * @property {Auth0Edges} auth0Identities
     */
    /**
     * @typedef Auth0Edges
     * @property {{node: UserIdentity}[]} edges
     */
    /**
     * @typedef UserIdentity
     * @property {string} provider
     * @property {string} identityUserId
     */
    fetchUserIdentities = async () => {
        const {auth0Profile} = getAuth0Storage();
        /** @type import('apollo-client').ApolloQueryResult<Auth0IdentityData> */
        const {data} = await gqlClient.client.query({
            query: gql`
                query UserIdentities($auth0UserId: ID!) {
                    auth0Identities(auth0UserId: $auth0UserId) {
                        edges {
                            node {
                                provider
                                identityUserId
                            }
                        }
                    }
                }
            `,
            variables: {
                auth0UserId: auth0Profile.sub
            }
        });
        const isFbBusinessConnected = data.auth0Identities.edges.some(
            ({node}) => node.provider === 'facebook'
        );
        const isTikTokBusinessConnected = data.auth0Identities.edges.some(({node}) =>
            node.identityUserId.toString().includes('tiktok-business')
        );
        this.setState({isTikTokBusinessConnected});
        this.setState({isFbBusinessConnected});
    };

    fetchCompositionMetrics = async () => {
        let hasNextPage = true;
        let endCursor = null;
        let metricsDictionary = {};

        // Paginate over campaignCompositions and append to metricsDictionary
        while (hasNextPage) {
            const {data: compositionMetrics} = await gqlClient.client.query({
                query: gql`
                    query($after: After, $campaignId: ID!, $search: JSON!) {
                        campaignCompositions(first: 250, after: $after, campaignId: $campaignId) {
                            pageInfo {
                                hasNextPage
                                endCursor
                            }
                            edges {
                                node {
                                    id
                                    type

                                    ... on InstagramStoryCollection {
                                        ... on InstagramStoryCollection {
                                            distributionMetricSearch(
                                                kind: INSTAGRAM_STORY_SEGMENT
                                                search: $search
                                            ) {
                                                rawSearchResult
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                `,
                variables: {
                    campaignId: this.props.campaignId,
                    after: endCursor,
                    search: JSON.stringify({
                        size: 10000,
                        query: {bool: {must: [{match: {version: 1}}]}}
                    })
                }
            });

            const pageInfo = R.pathOr(
                {
                    hasNextPage: false,
                    endCursor: null
                },
                ['campaignCompositions', 'pageInfo'],
                compositionMetrics
            );

            hasNextPage = pageInfo.hasNextPage;
            endCursor = pageInfo.endCursor;

            metricsDictionary = R.pipe(
                R.pathOr([], ['campaignCompositions', 'edges']),
                // extract node
                R.map(({node}) => ({
                    ...node,
                    distributionMetricSearch: {
                        rawSearchResult: JSON.parse(node.distributionMetricSearch.rawSearchResult)
                    }
                })),
                R.reduce((dict, node) => {
                    return {
                        ...dict,
                        [node.id.toString()]: node
                    };
                }, {}),
                // May not be initialized yet so || {}
                R.merge(metricsDictionary || {})
            )(compositionMetrics);
        }

        this.setState({compositionMetrics: metricsDictionary});
    };

    /**
     * @param {(number | string)} id
     * @memberof AnalyticsPostsContainer
     */
    getCompositionMetricsByCompositionId = id => {
        const node =
            R.pathOr(null, [id], this.state.compositionMetrics) ||
            R.pathOr(null, [id.toString()], this.state.compositionMetrics);

        if (!node) {
            return null;
        }

        return {
            id: node.id,
            type: node.type,
            metrics: R.path(['distributionMetricSearch', 'rawSearchResult', 'hits', 'hits'], node)
        };
    };

    handleAdvancedOptionsClick = () => {
        const {hideDateSelect} = this.props;

        if (this.state.expanded) {
            hideDateSelect();
        }

        this.setState({
            expanded: !this.state.expanded
        });
    };

    changeIncludeContentFilter = filter => {
        const {includeContentFilters: contentFilters} = this.state;
        const filterIsSelected = R.contains(filter, contentFilters);
        const selectedWithFilter = R.concat(contentFilters, [filter]);
        const selectedWithoutFilter = R.reject(R.equals(filter), contentFilters);
        this.setState({
            includeContentFilters: filterIsSelected ? selectedWithoutFilter : selectedWithFilter
        });
    };

    changeExcludeContentFilter = filter => {
        const {excludeContentFilters: contentFilters} = this.state;
        const filterIsSelected = R.contains(filter, contentFilters);
        const selectedWithFilter = R.concat(contentFilters, [filter]);
        const selectedWithoutFilter = R.reject(R.equals(filter), contentFilters);
        this.setState({
            excludeContentFilters: filterIsSelected ? selectedWithoutFilter : selectedWithFilter
        });
    };

    clearFilter = () => {
        this.setState({
            includeContentFilters: [],
            excludeContentFilters: []
        });
    };

    changeCardSize = (sliderPosition, direction) => {
        if (direction) {
            if (direction === 'up') {
                /*
                 * Finding the current index of the slider and if it's not at the end,
                 * incrementing it for the new position
                 */
                const currentPositionIdx = R.indexOf(sliderPosition, SliderMarksArray);
                const newPositionIdx =
                    currentPositionIdx === 3 ? currentPositionIdx : currentPositionIdx + 1;
                const newPosition = SliderMarksArray[newPositionIdx];
                const newCardSize = SliderMarks[newPosition];

                this.setState({
                    currentSliderPosition: newPosition,
                    currentCardSize: newCardSize
                });
            }

            if (direction === 'down') {
                /*
                 * Finding the current index of the slider and if it's not at the end,
                 * incrementing it for the new position
                 */
                const currentPositionIdx = R.indexOf(sliderPosition, SliderMarksArray);
                const newPositionIdx =
                    currentPositionIdx === 0 ? currentPositionIdx : currentPositionIdx - 1;
                const newPosition = SliderMarksArray[newPositionIdx];
                const newCardSize = SliderMarks[newPosition];

                this.setState({
                    currentSliderPosition: newPosition,
                    currentCardSize: newCardSize
                });
            }
        } else {
            const newCardSize = SliderMarks[sliderPosition];

            this.setState({
                currentSliderPosition: sliderPosition,
                currentCardSize: newCardSize
            });
        }
    };

    changeViewMode = selectedDisplayMode => {
        const {enableClickTracking} = this.state;
        const {brandName, campaignId, campaignName, email, isAdmin} = this.props;
        const isBrandUserAndDisplayGrid = !isAdmin && selectedDisplayMode === DisplayMode.GRID;
        const isBrandUserAndDisplayList = !isAdmin && selectedDisplayMode === DisplayMode.LIST;

        // changeViewMode is fired on page load, so we initially set it to false
        // once page loads, we want to track view mode clicks
        if (isBrandUserAndDisplayGrid && enableClickTracking) {
            track(email, 'Brand gallery grid view clicked', {
                'Campaign Funnel Name': campaignName || 'Brand Content Gallery',
                'Campaign Funnel Id': campaignId || 'Brand Content Gallery',
                'Brand Name': brandName
            });
        } else if (isBrandUserAndDisplayList && enableClickTracking) {
            track(email, 'Brand gallery list view clicked', {
                'Campaign Funnel Name': campaignName || 'Brand Content Gallery',
                'Campaign Funnel Id': campaignId || 'Brand Content Gallery',
                'Brand Name': brandName
            });
        }

        this.setState(
            {
                currentDisplayMode: selectedDisplayMode,
                enableClickTracking: true
            },
            this.clearFilter
        );
    };

    changeRateCreatorsMode = rateCreatorsModeIsActive => {
        const {isAgency, isBrand} = this.props;
        if (isAgency || isBrand) {
            const {oldDisplayMode, currentDisplayMode} = this.state;
            this.setState({
                rateCreatorsMode: rateCreatorsModeIsActive,
                currentDisplayMode: rateCreatorsModeIsActive ? DisplayMode.NONE : oldDisplayMode,
                oldDisplayMode: rateCreatorsModeIsActive ? currentDisplayMode : DisplayMode.NONE
            });
        }
    };

    changeContentType = selectedContentType => {
        this.setState({
            currentContentType: selectedContentType
        });
    };

    filterPostsByContentAndContentType = posts => {
        const {currentContentType, includeContentFilters, excludeContentFilters} = this.state;
        let filteredPosts;

        filteredPosts = R.filter(post => {
            if (currentContentType === `${ContentType.IMAGE}|${ContentType.VIDEO}`) {
                return true;
            }
            return currentContentType === post.content_type;
        }, posts);

        if (!R.isEmpty(includeContentFilters)) {
            filteredPosts = R.filter(post => {
                const {tags} = post;
                return !R.isEmpty(R.intersection(tags, includeContentFilters));
            }, filteredPosts);

            if (!R.isEmpty(excludeContentFilters)) {
                filteredPosts = R.filter(post => {
                    const {tags} = post;
                    return R.isEmpty(R.intersection(tags, excludeContentFilters));
                }, filteredPosts);
            }
        }

        return filteredPosts;
    };

    displayContentFilterTabs() {
        const {currentDisplayMode, excludeContentFilters, includeContentFilters} = this.state;

        return currentDisplayMode === DisplayMode.GRID ? (
            <ContentFiltersTabs
                changeIncludeContentFilter={this.changeIncludeContentFilter}
                changeExcludeContentFilter={this.changeExcludeContentFilter}
                includeContentFilters={includeContentFilters}
                excludeContentFilters={excludeContentFilters}
            />
        ) : null;
    }

    displayPosts = () => {
        const {currentCardSize, currentDisplayMode, rateCreatorsMode} = this.state;
        const {
            campaignId,
            posts,
            setPostScore,
            showPostScore,
            showKoer,
            showViews,
            rateCreatorUrl,
            commentOnCreatorUrl,
            contentWorkflow,
            campaignType,
            handleRequestSparkAdAuth
        } = this.props;

        const workflow = getCampaignWorkflow(contentWorkflow);

        const filteredPosts = R.pipe(
            this.filterPostsByContentAndContentType,
            R.filter(
                p =>
                    getCampaignWorkflow(p.campaign_content_workflow).displayUndistributedContent ||
                    p.content_distribution_metadata
            )
        )(posts);

        if (rateCreatorsMode) {
            return (
                <RateCreatorsList
                    posts={filteredPosts}
                    campaignId={campaignId}
                    rateCreatorUrl={rateCreatorUrl}
                    commentOnCreatorUrl={commentOnCreatorUrl}
                />
            );
        } else if (R.isEmpty(posts)) {
            return <div>No Items to Display</div>;
        } else if (currentDisplayMode === DisplayMode.GRID) {
            const cardProps = {
                currentCardSize,
                setPostScore,
                showPostScore,
                setSelectedPost: this.setSelectedPost,
                setSelectedPostAndComment: this.setSelectedPostAndComment,
                showKoer,
                showViews,
                showAvgScore: true
            };

            return (
                <PostGrid
                    undistributedContent
                    posts={filteredPosts}
                    cardProps={cardProps}
                    partitionContent={workflow.partitionContent}
                    getCompositionMetricsByCompositionId={this.getCompositionMetricsByCompositionId}
                />
            );
        }

        return (
            <div className="list-mode">
                <PostsList
                    posts={filteredPosts}
                    setPostScore={setPostScore}
                    setSelectedPost={this.setSelectedPost}
                    showKoer={showKoer}
                    campaignType={campaignType}
                    handleRequestSparkAdAuth={handleRequestSparkAdAuth}
                    handleCopyToClipboard={this.props.handleCopyToClipboard}
                />
            </div>
        );
    };

    displayModal() {
        const {selectedPost, campaignId, brandName, email} = this.props;
        const noneSelected =
            R.isNil(selectedPost) || !R.has('content_distribution_metadata')(selectedPost);
        if (noneSelected) return null;

        const modalProps = {
            show: this.props.showContentModal,
            showDownloadSurvey: this.props.showDownloadSurvey,
            showDownloadSurveyThankYou: this.props.showDownloadSurveyThankYou,
            close: this.props.closeContentModal,
            downloadUrl: this.props.downloadUrl,
            isAdmin: this.props.isAdmin,
            isSalesUser: this.props.isSalesUser,
            post: selectedPost,
            setPostScore: this.props.setPostScore,
            setContentComment: this.props.setContentComment,
            handleDownloadContent: this.props.handleDownloadContent,
            handleSubmitContentDownloadSurvey: this.props.handleSubmitContentDownloadSurvey,
            shareToFacebookAdManager: this.props.shareToFacebookAdManager,
            shareToFacebookPagesAccount: this.props.shareToFacebookPagesAccount,
            shareToSnapchatAdManager: this.props.shareToSnapchatAdManager,
            shareToTwitterAdManager: this.props.shareToTwitterAdManager,
            shareToPinterest: this.props.shareToPinterest,
            createPinterestBoard: this.props.createPinterestBoard,
            shareOptions: this.props.shareOptions,
            campaignId,
            campaignName: this.props.campaignName,
            brandName,
            email,
            showPostScore: this.props.showPostScore,
            showAvgScore: true,
            previewAdMode: this.state.previewAdMode,
            showContentComment: this.props.showContentComment,
            postUserComment: this.props.selectedPostComment,
            campaignType: this.props.campaignType
        };

        if (selectedPost.content_type === ContentType.IMAGE) {
            return <ImageModal {...modalProps} />;
        }

        return <VideoModal {...modalProps} />;
    }

    displayClearAllFiltersControl() {
        const {
            currentDisplayMode,
            includeContentFilters,
            excludeContentFilters
        } = this.state;

        if (currentDisplayMode !== DisplayMode.GRID) return null;
        if (R.isEmpty(R.concat(includeContentFilters, excludeContentFilters))) return null;
        
        return <ClearAllFiltersControl clearFilter={this.clearFilter} />;
    }
    
    displayAdvancedOptions = () => {
        const {isAgency, isBrand, isRateCreatorsDisabled} = this.props;
        const {expanded} = this.state;

        const clearAllFiltersControl = this.displayClearAllFiltersControl();

        if (expanded) {
            const contentFilterTabs = this.displayContentFilterTabs();

            return (
                <>
                    <PostsControlsRow
                        changeContentType={this.changeContentType}
                        changeIncludeContentFilter={this.changeIncludeContentFilter}
                        changeExcludeContentFilter={this.changeExcludeContentFilter}
                        changeCardSize={this.changeCardSize}
                        changeViewMode={this.changeViewMode}
                        showRateCreatorsToggle={(isAgency || isBrand) && !isRateCreatorsDisabled}
                        changeRateCreatorsMode={this.changeRateCreatorsMode}
                        clearFilter={this.clearFilter}
                        currentContentType={this.state.currentContentType}
                        currentSliderPosition={this.state.currentSliderPosition}
                        currentSortColumn={this.props.currentSortColumn}
                        currentDisplayMode={this.state.currentDisplayMode}
                        displayDatePicker={this.props.displayDatePicker}
                        excludeContentFilters={this.state.excludeContentFilters}
                        handleDateRangeChange={this.props.handleDateRangeChange}
                        includeContentFilters={this.state.includeContentFilters}
                        showBidAndBudgetRow={this.props.showBidAndBudgetRow}
                        showKoer={this.props.showKoer}
                        sortByProperty={this.props.sortByProperty}
                        selectedStart={this.props.selectedStart}
                        selectedEnd={this.props.selectedEnd}
                        dateSelectedIdx={this.props.dateSelectedIdx}
                        dateSelectActive={this.props.dateSelectActive}
                        campaignId={this.props.campaignId}
                        posts={this.props.posts}
                    />

                    <div className='content-tags-container'>
                        {contentFilterTabs}

                        {clearAllFiltersControl}
                    </div>
                </>
            );
        }
        return null;
    };

    hideBanner = () => {
        this.setState({showBanner: false});
    };

    setSelectedPost = contentMetadataId => {
        this.setState(
            {
                previewAdMode: false
            },
            this.props.setSelectedPost(contentMetadataId)
        );
    };

    setSelectedPostAndComment = contentMetadataId => {
        this.setState(
            {
                previewAdMode: false
            },
            this.props.setSelectedPostAndComment(contentMetadataId)
        );
    };

    render() {
        const {loading} = this.props;

        if (loading) {
            return <LoaderSpinner />;
        }

        const advancedOptionsExpanded = this.displayAdvancedOptions();
        const posts = this.displayPosts();
        const modal = this.displayModal();

        return (
            <div className="analytics-posts-container">
                <div className="sn-social-banners">
                    <FeatureFlag
                        flagKey="fb-business-banner-enabled"
                        renderFeatureCallback={featureFlagValue => {
                            if (!featureFlagValue || featureFlagValue === 'off') {
                                return null;
                            }
                            return (
                                <FbBusinessBanner
                                    isFbBusinessConnected={this.state.isFbBusinessConnected}
                                    campaignId={this.props.campaignId}
                                />
                            );
                        }}
                    />

                    <FeatureFlag
                        flagKey="upload-to-tiktok-csf-enabled"
                        renderFeatureCallback={featureFlagValue => {
                            if (!featureFlagValue || featureFlagValue === 'off') {
                                return null;
                            }
                            return (
                                this.state.isHideTikTokBanner && (
                                    <TikTokBusinessBanner
                                        isTikTokConnected={this.state.isTikTokBusinessConnected}
                                        campaignId={this.props.campaignId}
                                    />
                                )
                            );
                        }}
                    />
                </div>

                <div className="advanced-options-container">
                    <PostGridOptions
                        expanded={this.state.expanded}
                        handleAdvancedOptionsClick={this.handleAdvancedOptionsClick}
                        fullStartDate={this.props.fullStartDate}
                        fullEndDate={this.props.fullEndDate}
                    />

                    {advancedOptionsExpanded}
                </div>

                <div className="panel post-analytics-panel">
                    <div data-platform="instagram" className="grid-mode clearfix">
                        {posts}
                    </div>
                </div>
                {modal}
            </div>
        );
    }
}

/**
 * @param {{isFbBusinessConnected: boolean, campaignId: string}} props
 * @return {JSX.Element}
 */
function FbBusinessBanner(props) {
    const {isFbBusinessConnected, campaignId} = props;

    if ([null, true].includes(isFbBusinessConnected)) return null;

    const ctaButtonUrl = `/distributions?campaign_id=${campaignId}&distribution_type=facebook_paid`;

    return (
        <div className="connect-banner fb-connect-banner">
            <div className="connect-banner-logo-group">
                <img
                    className="connect-banner-logo"
                    src={FacebookPlusSocialNativeIcon}
                    alt="Facebook + Social Native"
                />
                <div className="connect-banner-headline">
                    Send content to your Facebook Ads Manager
                </div>
            </div>
            <a href={ctaButtonUrl} className="connect-banner-button">
                CONNECT WITH FACEBOOK
            </a>
        </div>
    );
}

function TikTokBusinessBanner(props) {
    const {isTikTokConnected, campaignId} = props;

    if ([null, true].includes(isTikTokConnected)) return null;

    const ctaButtonUrl = `/distributions?campaign_id=${campaignId}&distribution_type=facebook_paid`;

    return (
        <div className="connect-banner tiktok-connect-banner">
            <div className="connect-banner-logo-group">
                <img
                    className="connect-banner-logo"
                    src={TikTokPlusSocialNativeIcon}
                    alt="TikTok + Social Native"
                />
                <div className="connect-banner-headline">
                    Send content to your TikTok Ads Manager
                </div>
            </div>
            <a href={ctaButtonUrl} className="connect-banner-button">
                CONNECT WITH TIKTOK
            </a>
        </div>
    );
}

AnalyticsPostsContainer.propTypes = {
    campaignId: PropTypes.number.isRequired,
    contentWorkflow: PropTypes.string,
    closeContentModal: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isAgency: PropTypes.bool.isRequired,
    isBrand: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    posts: PropTypes.array.isRequired,
    shareToFacebookAdManager: PropTypes.func.isRequired,
    shareToFacebookPagesAccount: PropTypes.func.isRequired,
    shareToSnapchatAdManager: PropTypes.func.isRequired,
    selectedPost: PropTypes.object.isRequired,
    setPostScore: PropTypes.func.isRequired,
    showPostScore: PropTypes.bool.isRequired,
    setSelectedPost: PropTypes.func.isRequired,
    setSelectedPostAndComment: PropTypes.func.isRequired,
    showContentModal: PropTypes.bool.isRequired,
    sortByProperty: PropTypes.func.isRequired,
    showKoer: PropTypes.number.isRequired,
    showViews: PropTypes.number.isRequired,
    rateCreatorUrl: PropTypes.string,
    commentOnCreatorUrl: PropTypes.string,
    showContentComment: PropTypes.bool.isRequired,
    selectedPostComment: PropTypes.string,
    campaignType: PropTypes.string,
    handleRequestSparkAdAuth: PropTypes.func,
    handleCopyToClipboard: PropTypes.func.isRequired
};

export default AnalyticsPostsContainer;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/index.js